export function formatMinutes(minutes: number): string {
  const sign = minutes < 0 ? "-" : "";
  const total = Math.abs(minutes);

  return `${sign}${Math.floor(total / 60)}h${String(total % 60).padStart(2, "0")}`;
}

export function minutesBetween(
  begin: string | null | undefined,
  end: string | null | undefined,
): number | null {
  const from = minutesOfDay(begin);
  const to = minutesOfDay(end);

  if (null === from || null === to || to <= from) {
    return null;
  }

  return to - from;
}

function minutesOfDay(value: string | null | undefined): number | null {
  const match = /^(\d{1,2}):(\d{2})$/u.exec(value ?? "");

  return match ? Number(match[1]) * 60 + Number(match[2]) : null;
}
